__turbopack_context__.v({
  "heading": "CoreHeading-module-scss-module__CCmYAG__heading",
});
